// encryption.service.ts
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {

  private key = CryptoJS.enc.Utf8.parse('9115568540simone9876543210simons'); // 32 chars
  private iv  = CryptoJS.enc.Utf8.parse('simonslis12347896');                 // 16 chars
  
  encrypt(encrypt: string): string {
    const encrypted = CryptoJS.AES.encrypt(encrypt, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return encrypted.toString(); // Base64
  }

  decrypt(encrypted: string): number {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const result = decrypted.toString(CryptoJS.enc.Utf8);
    return Number(result);
  }
}
